import { __assign } from "tslib";
import { POLL_TYPE } from 'wix-rich-content-common';
import { PollsService } from './PollsService';
var isSSR = function () { return typeof window === 'undefined'; };
var fetchMembers = function (instance, getHttpClientPromise) {
    return getHttpClientPromise().then(function (httpClientInstance) {
        var membersPromise = httpClientInstance
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .get('/_api/wix-sm-webapp/v1/profiles?limit=100', {
            headers: {
                Authorization: instance,
            },
        })
            .then(function (res) {
            var _a;
            if (res.status === 200)
                return (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.profiles;
            else
                throw res.statusText;
        })
            .catch(function (e) {
            // TODO: fix api for EditorX
            // eslint-disable-next-line no-console
            console.error('[pollsStrategy] fetchMembers failed. error:', e);
            return [];
        });
        return membersPromise;
    });
};
var normalizeMembers = function (rawMembers) {
    var _a;
    return (_a = rawMembers === null || rawMembers === void 0 ? void 0 : rawMembers.map) === null || _a === void 0 ? void 0 : _a.call(rawMembers, function (member) {
        return {
            siteMemberId: member.id,
            imageUrl: member.imageUrl,
            name: {
                nick: member.nickname,
            },
        };
    });
};
var members;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function pollsStrategy(instance, getHttpClientPromise, experiments) {
    var _a;
    var _b;
    if (!instance)
        return {};
    // TODO: trigger getSiteMembers & fetch inside polls and wait for response
    !isSSR() &&
        !members &&
        fetchMembers(instance, getHttpClientPromise)
            .then(normalizeMembers)
            .then(function (fetchedMembers) { return (members = fetchedMembers); });
    return {
        config: (_a = {},
            _a[POLL_TYPE] = __assign(__assign({}, (((_b = experiments === null || experiments === void 0 ? void 0 : experiments.pollsRicosServiceV2) === null || _b === void 0 ? void 0 : _b.enabled) && {
                pollServiceApi: new PollsService(instance, getHttpClientPromise),
            })), { siteToken: instance, getSiteMembers: function () { return members; } }),
            _a),
    };
}
//# sourceMappingURL=pollsStrategy.js.map